import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { BULK_BTN_SIZE } from '../virtualList/constants';

import { BulkAdd } from './BulkAdd';
import { StyledBulkInputPlusSignIcon } from './BulkInputPlusSignIcon.styled';
import { StyledBulkPlaceholderDiv } from './BulkPlaceholderDiv.styled';
import { useBulkAdd } from './hooks/useBulkAdd';
import type { BulkValidationReturnType } from './types';

export type BulkInputProps = {
  isDisabled: boolean;
  validate: (items: string[]) => BulkValidationReturnType;
  onAdd: (items: string[]) => void;
};

export const BulkInput = ({ validate, onAdd, isDisabled }: BulkInputProps) => {
  const { t } = useTranslation();
  const { isBulkOpen, onBulkAdd, onBulkClose, onBulkOpen } = useBulkAdd({ onAdd });

  return isBulkOpen ? (
    <>
      <StyledBulkPlaceholderDiv height={BULK_BTN_SIZE} />
      <BulkAdd onApply={onBulkAdd} onClose={onBulkClose} validate={validate} isDisabled={isDisabled} />
    </>
  ) : (
    <StyledBulkPlaceholderDiv height={BULK_BTN_SIZE} onClick={onBulkOpen}>
      <Button variant="text" disabled={isDisabled}>
        <StyledBulkInputPlusSignIcon /> <Typography variant="button">{t('Bulk add')}</Typography>
      </Button>
    </StyledBulkPlaceholderDiv>
  );
};
